import React from 'react';

import { Link, Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const ProjectFormatter = ({ row }) => {
    const contact = get(row, 'contact', null);
    const project = get(row, 'project', null);

    if (!project || !project.id) {
        return <Typography variant="caption">---</Typography>;
    }

    return (
        <Link
            color="inherit"
            component={RouterLink}
            to={`/contacts/${contact.id}/${project.id}`}
            underline="none"
        >
            <Typography fontWeight={600} variant="caption">
                {project.name}
            </Typography>
        </Link>
    );
};

ProjectFormatter.propTypes = {
    row: PropTypes.object,
};

export default ProjectFormatter;
